import React from "react";
// UI Framework
import { toast } from "react-toastify";
// Common Components
import { Button, TimePicker } from "src/Components";
// Services
import {
  getLiquidityManagementConfig,
  setLiquidityManagementConfig,
} from "src/Requests/imePortfolio";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
// Types
import { ILiquidityManagementConfig } from "src/Interfaces/imePortfolio";

interface IProps {
  onClose?: () => void;
}
const SettingModal: React.FC<IProps> = ({ onClose }) => {
  const [loading, setLoading] = React.useState(false);
  const [formValues, setFormValues] =
    React.useState<ILiquidityManagementConfig>(
      {} as ILiquidityManagementConfig,
    );

  React.useEffect(() => {
    setLoading(true);
    getLiquidityManagementConfig()
      .then((resp) => setFormValues(resp))
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }, []);

  const getTimePickerValue = (value?: string) => {
    if (!value) return null;
    if (value.includes("T")) return value;
    return `${new Date().toISOString().slice(0, 10)}T${value}`;
  };

  const changeHandler = (
    name: string,
    value: { timeString: string; ISOString: string | null },
  ) => {
    setFormValues({ ...formValues, [name]: value.timeString });
  };

  const submitHandler = () => {
    setLoading(true);
    setLiquidityManagementConfig(formValues)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          if (onClose) onClose();
        } else {
          toast.error(resp.msg);
        }
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <div className="flex flex-col justify-start items-start gap-4 min-w-[360px] p-2">
      <TimePicker
        name="withdrawStartTime"
        value={getTimePickerValue(formValues.withdrawStartTime)}
        onChange={changeHandler}
        placeholder="ساعت شروع برداشت"
        extraLabel
      />
      <TimePicker
        name="withdrawEndTime"
        value={getTimePickerValue(formValues.withdrawEndTime)}
        onChange={changeHandler}
        placeholder="ساعت پایان برداشت"
        extraLabel
      />
      <div className="w-16 self-center">
        <Button
          text="ثبت"
          onClick={submitHandler}
          variant="contained"
          loading={loading}
          disabled={
            loading ||
            !formValues.withdrawStartTime ||
            !formValues.withdrawEndTime
          }
        />
      </div>
    </div>
  );
};

export default SettingModal;
